/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Letter_Spacing_LabelInputs */

const en_video_export_letter_spacing_label = /** @type {(inputs: Video_Export_Letter_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letter Spacing`)
};

const fr_video_export_letter_spacing_label = /** @type {(inputs: Video_Export_Letter_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacement des lettres`)
};

const de_video_export_letter_spacing_label = /** @type {(inputs: Video_Export_Letter_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchstabenabstand`)
};

const it_video_export_letter_spacing_label = /** @type {(inputs: Video_Export_Letter_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spaziatura delle lettere`)
};

const ru_video_export_letter_spacing_label = /** @type {(inputs: Video_Export_Letter_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Межбуквенный интервал`)
};

const es_video_export_letter_spacing_label = /** @type {(inputs: Video_Export_Letter_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaciado entre letras`)
};

const zh_cn2_video_export_letter_spacing_label = /** @type {(inputs: Video_Export_Letter_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字母间距`)
};

const ja_video_export_letter_spacing_label = /** @type {(inputs: Video_Export_Letter_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字間隔`)
};

const hi_video_export_letter_spacing_label = /** @type {(inputs: Video_Export_Letter_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पत्र अंतराल`)
};

const pt_pt2_video_export_letter_spacing_label = /** @type {(inputs: Video_Export_Letter_Spacing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaçamento entre letras`)
};

/**
* | output |
* | --- |
* | "Letter Spacing" |
*
* @param {Video_Export_Letter_Spacing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_letter_spacing_label = /** @type {((inputs?: Video_Export_Letter_Spacing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Letter_Spacing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_letter_spacing_label(inputs)
	if (locale === "de") return de_video_export_letter_spacing_label(inputs)
	if (locale === "it") return it_video_export_letter_spacing_label(inputs)
	if (locale === "ru") return ru_video_export_letter_spacing_label(inputs)
	if (locale === "es") return es_video_export_letter_spacing_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_letter_spacing_label(inputs)
	if (locale === "ja") return ja_video_export_letter_spacing_label(inputs)
	if (locale === "hi") return hi_video_export_letter_spacing_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_letter_spacing_label(inputs)
	return en_video_export_letter_spacing_label(inputs)
});